/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getSelectionOffsetKeyForNode
 * @typechecks
 * 
 */

'use strict';

/**
 * Get offset key from a node.
 */
function getSelectionOffsetKeyForNode(node) {
  return node instanceof Element ? node.getAttribute('data-offset-key') : null;
}

module.exports = getSelectionOffsetKeyForNode;


/*****************
 ** WEBPACK FOOTER
 ** ./~/draft-js/lib/getSelectionOffsetKeyForNode.js
 ** module id = 494
 ** module chunks = 0 2
 **/